<template>
  <div class="body">
    <z-header></z-header>
    <router-view />
    <z-footer></z-footer>
    <FloatBtn />
  </div>
</template>

<script>
import ZHeader from '@/components/GlobalHeader/ZHeader'
import ZFooter from '@/components/GlobalFooter/ZFooter'
import FloatBtn from '@/components/FloatBtn/FloatBtn'
export default {
  components: {
    ZFooter,
    ZHeader,
    FloatBtn
  }
}
</script>

<style>
body{
  overflow-x: scroll;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/layout/BasicLayout.vue